export default __webpack_public_path__ + "static/media/industry1.6cfb0ddf.png";